import React from 'react';

const notifications = [
	['solar:check-circle-outline', 'text-body text-opacity-50', 'Task Completed', 'Q3 Financial Report approved by board members', 'Finance Team', '9:42 AM'],
	['solar:users-group-rounded-outline', 'text-body text-opacity-50', 'Team Update', '2 new members added to Project Orion team', 'Alex Chen', '9:30 AM'],
	['solar:calendar-mark-outline', 'text-indigo', 'Meeting Reminder', 'Board Meeting in Conference Room A - 30 minutes', 'Calendar', '9:15 AM'],
	['solar:chart-outline', 'text-primary', 'Performance Report', 'Weekly analytics dashboard has been updated', 'Analytics Team', '8:55 AM'],
	['solar:gift-outline', 'text-pink', 'Work Anniversary', 'Celebrating 3 years with the company today!', 'HR Department', '8:30 AM'],
	['solar:clock-circle-outline', 'text-body text-opacity-50', 'Deadline Approaching', 'Project submission due in 2 days - Marketing Campaign', 'Project Manager', 'Yesterday, 4:20 PM']
];

const earlierNotifications = [
	['solar:file-text-outline', 'text-body text-opacity-50', 'Document Shared', 'Budget proposal shared with marketing team', 'Sarah Johnson', 'Yesterday'],
	['solar:shield-warning-outline', 'text-danger', 'Security Alert', 'New login from unknown device', 'Security Team', '2 days ago'],
	['solar:server-outline', 'text-info', 'System Update', 'Scheduled maintenance completed successfully', 'IT Department', '2 days ago'],
	['solar:wallet-outline', 'text-warning', 'Expense Approved', 'Business travel expenses have been processed', 'Accounting', '4 days ago'],
	['solar:like-outline', 'text-success', 'Kudos Received', 'Your presentation was praised by the executive team', 'Michael Brown', '3 days ago'],
	['solar:chat-line-outline', 'text-primary', 'New Message', 'You have unread messages in the project channel', 'Team Chat', '5 days ago']
];

function NotificationItem({ item, unread = false }) {
	const [icon, color, title, description, owner, time] = item;
	return (
		<div className="dropdown-item rounded-3 p-2">
			<div className="d-flex align-items-start gap-2">
				<iconify-icon icon={icon} className={`${color} fs-3 m-1`}></iconify-icon>
				<div className="flex-1">
					<div className="fw-bold text-dark">{title}</div>
					<div className="fw-semibold small text-muted mb-2">{description}</div>
					<div className="fw-semibold small d-flex align-items-center gap-2"><span>{owner}</span><i className="fa fa-circle fs-4px text-body text-opacity-50"></i><span>{time}</span></div>
				</div>
				{unread && <i className="fa fa-circle text-primary fs-9px"></i>}
			</div>
		</div>
	);
}

function DropdownNotification() {
	return (
		<div className="menu-item dropdown">
			<a href="#/" data-bs-toggle="dropdown" className="menu-link" aria-label="Open notifications">
				<iconify-icon icon="solar:bell-bing-bold-duotone"></iconify-icon><span className="badge">8</span>
			</a>
			<div className="dropdown-menu dropdown-menu-end w-350px w-lg-400px overflow-hidden p-0 rounded-3">
				<div className="d-flex flex-column dropdown-app-header-mh">
					<div className="bg-gray-800 text-white px-3 py-3 fw-bold d-flex align-items-center gap-2"><iconify-icon icon="solar:bell-bing-bold-duotone" className="fs-4 my-n1"></iconify-icon> Alerts &amp; Notifications</div>
					<div className="flex-1" data-scrollbar="true">
						<div className="py-2 px-3 fw-bold d-flex mt-1"><span className="flex-1">New</span><a href="#/" className="fw-semibold text-decoration-none">See all</a></div>
						<div className="px-2 d-flex flex-column gap-2">{notifications.map((item) => <NotificationItem key={item[2]} item={item} unread />)}</div>
						<hr />
						<div className="py-2 px-3 fw-bold d-flex mt-3"><span className="flex-1">Earlier</span></div>
						<div className="px-2 d-flex flex-column gap-2 mb-3">{earlierNotifications.map((item) => <NotificationItem key={item[2]} item={item} />)}</div>
					</div>
					<hr className="m-0" />
					<div className="px-3 py-2 text-center"><a href="#/" className="fw-semibold text-decoration-none link-secondary d-block my-1">Mark all as read</a></div>
				</div>
			</div>
		</div>
	);
}

export default DropdownNotification;
